module.exports = __webpack_public_path__ + "static/media/400049_02.de3ad8d1.png";